
const serverConfig = require('../../../infrastructure/serverConfig')

module.exports = ['$scope', '$translate', 'contactListService', 'contactListMixin', '$stateParams', '$state', '$phoneModal',
  '$rootScope', '$sce', '$location', '$ionicPlatform', '$timeout', '$utils', '$ionicHistory', 'contactService', '$q', 'User', 'LocalStorage', 'globalMailService', '$ionicListDelegate',
  '$ionicViewSwitcher',
  function ($scope, $translate, contactListService, ContactListMixin, $stateParams, $state, $phoneModal, $rootScope, $sce, $location, $ionicPlatform,
    $timeout, $utils, $ionicHistory, contactService, $q, User, LocalStorage, globalMailService, $ionicListDelegate, $ionicViewSwitcher) {
    const matchPath = /^\/([a-z0-9_\-.]*)(?:(?:\/[a-z0-9_\-.]*)*\/([a-z0-9_\-.]*))*/g.exec($stateParams.path)
    const dn = matchPath[1] + (matchPath[2] ? '/' + matchPath[2] : '') // 用于获取组织/部门架构
    if (dn !== '') {
      $scope.showBack = true
    }
    $scope.previousPath = $stateParams.path.replace(new RegExp('/' + (matchPath[2] ? matchPath[2] : matchPath[1]) + '$'), '') || '/' // 组织/部门上一层级
    $scope.path = $stateParams.path === '/' ? '' : $stateParams.path
    $scope.isOabRoot = $scope.path === ''
    // 根据配置调整通讯录列表内用户和部门的显示顺序
    $scope.contactDisplayOrder = serverConfig.getItem('OabListOuAndUserDisplay') || ''

    getDepartmentList(dn)
    // 获取部门列表
    function getDepartmentList(dn) {
      $scope.isLoading = true
      contactListService.getAddress({
        attrIds: ['name', 'email'],
        dn
      }).then(function (data) {
        if (data.code === 'S_OK' && data.var) {
          $scope.departmentList = data.var.ou ? data.var.ou : (dn === '' ? data.var : [])
          $scope.orgName = data.var.name
          $scope.departmentList.forEach(function (address) {
            address.type = 'dept'
          })
          $scope.noDepartments = !$scope.departmentList.length
          if (dn !== '') {
            getContactList(dn)
          } else {
            $scope.isLoading = false
          }
        }
      }, function () {
      })
    }
    // 获取部门联系人列表
    function getContactList(dn) {
      $scope.start = 0
      $scope.limit = 50
      contactService.listEx(dn, $scope.start, $scope.limit).then(function (data) {
        $scope.contactList = data.var
        $scope.start = $scope.start + $scope.limit
        $scope.hasMoreListData = $scope.contactList.length < data.total
        $scope.noContacts = !$scope.contactList.length
      }, function () {
      }).finally(function () {
        $scope.isLoading = false
      })
    }
    // 更多部门联系人
    $scope.getMoreContactList = function () {
      contactService.listEx(dn, $scope.start, $scope.limit).then(function (data) {
        $scope.contactList = $scope.contactList.concat(data.var)
        $scope.start = $scope.start + $scope.limit
        $scope.hasMoreListData = $scope.contactList.length < data.total
        $scope.noContacts = !$scope.contactList.length
      }, function () {
      }).finally(function () {
      })
    }
    // 个人通讯录入口只出现在通讯录首页
    if ($state.params.path === '/') {
      $scope.showStarDeptContact = true
      $scope.showPersonalContact = true
      $scope.starDepartments = []
      $scope.starContacts = []
      $scope.myDepartmentOu = ''
      getStarDeptContact()
      contactService.getOabContact(User.getConfig().email).then(function (data) {
        if (data['@ou']) {
          $scope.myDepartmentOu = data['@ou']
        }
      }, function () {
      })
    } else {
      $scope.showStarDeptContact = false
      $scope.showPersonalContact = false
    }

    $scope.goSubFrame = function (frame, param = {}) {
      switch (frame) {
        case 'frame.personalContact':
          LA.track('A2C2')
          break
      }
      $state.go(frame, param)
    }

    // 点击组织通讯录部门进入下一层级
    $scope.intoNextLayer = function (path, id, starIn) {
      if (!path) {
        LA.track('A2C1')
      }
      if (starIn) {
        LocalStorage.setItem('starInBack', { starInPath: path + '/' + id, backPath: '/' })
      }
      $state.go('frame.contactList', { path: path + '/' + id })
    }
    // 进入我的部门
    $scope.intoMyDepartment = function () {
      LA.track('A2C3')
      LocalStorage.setItem('starInBack', { starInPath: '/' + $scope.myDepartmentOu, backPath: '/' })
      $state.go('frame.contactList', { path: '/' + $scope.myDepartmentOu })
    }

    // 搜索联系人
    $scope.searchContact = function () {
      $scope.isLoading = true
      $scope.search.notFoundKeyword = $scope.search.keyword
      contactService.searchOabContacts($scope.search.keyword, dn).then(function (oabResult) {
        if (dn === '') {
          contactService.searchPabContacts($scope.search.keyword).then(function (pabResult) {
            $scope.searchShowList = wrapContacts(oabResult.concat(pabResult))
          }, function () {
          })
        } else {
          $scope.searchShowList = wrapContacts(oabResult)
        }
      }, function () {
      }).finally(function () {
        $scope.isLoading = false
      })
    }
    // 对传入的联系人数组做一些包装处理（高亮操作等）
    function wrapContacts(contacts) {
      contacts.forEach(function (item) {
        if (item.type === 'oabContact') {
          item.highLightEmail = highLightKeyword($scope.search.keyword, item['email'])
          item.highLightName = highLightKeyword($scope.search.keyword, item['true_name'])
        }
        if (item.type === 'pabContact') {
          item.highLightName = highLightKeyword($scope.search.keyword, item['FN'])
          item.highLightEmail = highLightKeyword($scope.search.keyword, item['EMAIL;PREF'])
        }
      })
      return contacts
    }

    // 高亮字段中的关键字
    function highLightKeyword(keyword, contactName) {
      if (contactName) {
        keyword = keyword.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        const pattern = new RegExp(keyword, 'i')
        const tempName = contactName.replace(pattern, "<span class='highlight'>$&</span>")
        return $sce.trustAsHtml(tempName)
      }
    }
    // 点击搜索结果联系人
    $scope.handleSearchItemClick = function (contact) {
      if (contact.type === 'oabContact') {
        $state.go('frame.detail', {
          contactId: contact['@id'] || contact['email'],
          name: contact['true_name']
        })
      }
      if (contact.type === 'pabContact') {
        $state.go('frame.personalContactDetail', {
          contactid: contact.id
        })
      }
    }
    // 获取星标部门和星标联系人
    function getStarDeptContact() {
      contactService.getStarDeptContact('department').then(function (data) {
        $scope.starDepartments = data
      }, function (data) {
        $scope.starDepartments = data
      })
      contactService.getStarDeptContact('contact').then(function (data) {
        $scope.starContacts = data
      }, function (data) {
        $scope.starContacts = data
      })
    }
    // 设为星标部门
    $scope.markStarDept = function (path, id, name, email, avatar) {
      $ionicListDelegate.closeOptionButtons()
      contactService.markStar({ type: 'department', payload: { path, id, name, email, avatar } }).then(function (result) {
      }, function () {
      })
    }
    // 取消星标部门
    $scope.removeStarDept = function (deptid) {
      $ionicListDelegate.closeOptionButtons()
      contactService.removeStar({ type: 'department', id: deptid }).then(function (result) {
        result && $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.REMOVE_STAR_SUCCESS') })
        getStarDeptContact()
      }, function () {
      })
    }
    // 设为星标联系人
    $scope.markStarContact = function (id, name, email, avatar) {
      $ionicListDelegate.closeOptionButtons()
      contactService.markStar({ type: 'contact', payload: { id, name, email, avatar } }).then(function () {
      }, function () {
      })
    }
    // 取消星标联系人
    $scope.removeStarContact = function (contactid) {
      $ionicListDelegate.closeOptionButtons()
      contactService.removeStar({ type: 'contact', id: contactid }).then(function (result) {
        result && $utils.$notify.set({ message: $translate.instant('ADDRESSBOOK.REMOVE_STAR_SUCCESS') })
        getStarDeptContact()
      }, function () {
      })
    }
    // 是否为星标部门
    $scope.isStarDept = function (deptid) {
      return contactService.isStarDeptContact({ type: 'department', id: deptid })
    }
    // 是否为星标联系人
    $scope.isStarContact = function (contactid) {
      return contactService.isStarDeptContact({ type: 'contact', id: contactid })
    }
    // 进入星标部门
    $scope.inStarDept = function (path, id) {
      $scope.intoNextLayer(path, id, true)
    }
    // 打开搜索模态框
    let clearWatch
    $scope.inSearchPage = function () {
      LA.track('A2B2')
      $scope.search = {}
      setTimeout(function () {
        $scope.hint = false
        $scope.searching = false
        $scope.tempModal = $phoneModal.fromTemplate(require('views/addressBook/searchModal.html'), {
          scope: $scope,
          animation: 'scale-in'
        })
        $scope.tempModal.el.style.zIndex = 15
        $utils.$modalFunc.prepareModalBack($scope.tempModal)
        $scope.tempModal.show()
        $rootScope.isAddrRootSearch = true
        const currentStateId = $ionicHistory.currentView().stateId
        clearWatch = $scope.$watch(function () {
          return $ionicHistory.currentView().stateId
        }, function (newValue) {
          if (newValue === currentStateId && $scope.tempModal) {
            $scope.tempModal.show()
          } else if (!$scope.tempModal) {
            clearWatch()
          }
        })
        $scope.$broadcast('CONTACT_SEARCH.CONTENT_LOADED')
      }, 0)
    }
    // 用于进入联系人详情页
    $scope.inDetailPage = function (id, name, email) {
      if ($rootScope.settings.featureControl.addressBook.enablePersonal) {
        contactService.searchPabContactByEmail(email).then(function (data) {
          if (data.code === 'S_OK' && data.var.length !== 0) {
            $rootScope.isOabIn = true
            $state.go('frame.personalContactDetail', { contactid: data.var[0].id })
          } else {
            $state.go('frame.detail', { contactId: id, name: name })
          }
        }, function () {
          $state.go('frame.detail', { contactId: id, name: name })
        })
      } else {
        $state.go('frame.detail', { contactId: id, name: name })
      }
    }

    // 进入个人通讯录详情页
    $scope.inPersonalDetailPage = function (id, groupid) {
      $state.go('frame.personalContactDetail', { contactid: id, groupid: groupid })
    }
    // 返回
    $scope.goBack = function () {
      $ionicViewSwitcher.nextDirection(['back'])
      const starInBack = LocalStorage.getItem('starInBack')
      if (JSON.stringify(starInBack) !== '{}') {
        if (starInBack.starInPath === $scope.path) {
          $state.go('frame.contactList', { path: starInBack.backPath })
          LocalStorage.removeItem('starInBack')
        } else {
          $state.go('frame.contactList', { path: $scope.previousPath })
        }
      } else {
        $state.go('frame.contactList', { path: $scope.previousPath })
      }
    }

    $scope.closeSearchModal = function () {
      $scope.searchShowList = null
      clearWatch()
      $scope.tempModal.remove()
    }
    $timeout(_ => {
      $scope.$broadcast('ADDRESSBOOK.CONTENT_LOADED')
    }, 100)
  }]



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/contact/contactListCtrl.js